( function( $ ) {

$(document).ready(function(){
$('#bundle-button').on('click', function(g){
	g.preventDefault(); 
  var ding = $('.trial-link.active').attr('data-cart');
 window.location.href = "https://ruffgreens.com/pages/add-your-free-gift?pro_id="+ding;
});
  
	$('.trial-link').on('click', function(g){
      
      var m = 'https://ruffgreens.com/pages/add-your-free-gift?pro_id=';
	g.preventDefault();
		var id = $(this).attr('id');
		var v = $(this).attr('data-cart');
        $('#sizeer').attr('value', id);
		var p = $(this).attr('data-price');
		$('.trial-link').removeClass('active');
		$('#'+id).addClass('active');
		$('#size').text(id);
		$('#monthly_price, #left-price').text(p);
		$('#product_option').val(v);
        if( $('#faux').length ) {
          var t = m + v;
          $('#faux').attr("href", t);
        }
      if( $('#pro-select').length ) {
        var simple = $('select[name="id"]').val();
          var t = m + v;
          $('select[name="id"]').val(v).change();
        }
});

});
} )( jQuery );